  {{#if entity.dateOfEstablishment }}
  <tr class="gnd-infobox-date-of-establishment">
    <th>Gründung:</th>
    <td>{{ entity.dateOfEstablishment }}</td>
  </tr>
  {{/if}}

  {{#if entity.definition }}
  <tr class="gnd-infobox-definition">
    <th>Beschreibung:</th>
    <td>{{ entity.definition.[@value] }}</td>
  </tr>
  {{/if}}

  {{#if entity.gndSubjectCategory }}
  <tr class="gnd-infobox-subject-categories">
    <th>GND Schlagwortkategorien:</th>
    <td>
      <dl>
      {{#each (arrayify entity.gndSubjectCategory) as |sc|}}
        <dd class="gnd-infobox-subject-category">{{prefLabelInGraph sc.[@id] 'gnd-sc'}}</dd>
      {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}

  {{#if entity.owl:sameAs }}
  <tr class="gnd-infobox-same-as">
    <th>Gleichwertige Konzepte:</th>
    <td>
      <dl>
          {{#each (arrayify entity.owl:sameAs) as |subentity| }}
          <dd><a href="{{hrefGnd subentity.[@id]}}">{{hrefGnd subentity.[@id]}}</a></dd>
          {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}

  {{#if (variantName entity) }}
  <tr class="gnd-infobox-variant-names">
    <th>Varianten:</th>
    <td>
      <dl>
        {{#each (arrayify (variantName entity)) as |name|}}
        <dd class="gnd-infobox-variant-name">{{ name }}</dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
